import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import { useDispatch, useSelector } from 'react-redux'
import CreateScope from '../selectScope/CreateScope.jsx'
import { history } from '../../_redux/_store/history'
import queryString from 'query-string'
import SelectScopeMenu from "../selectScope/SelectScopeMenu.jsx"
import { persistFilterData } from "../../_redux/_actions/detailsPersistActions";
import {
  fetchFindingField,
  fetchSelectFindingRule,
} from '../../_redux/_actions/selectFindingRuleAction'
import { makeStyles } from '@material-ui/core/styles'
import { CreateScopeSuccess } from '../selectScope/CreateScope.jsx'
import { editFindingRule } from '../../_redux/_actions/selectFindingRuleAction'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import Button from '@material-ui/core/Button'
import { Paper, Box, Select, MenuItem } from '@material-ui/core'
import HelpBlockImg from '../../_assets/_images/helpBlock.png'
import ScopeList from '../selectScope/ScopeList.jsx'
import ErrorHandler from '../updateHandlers/ErrorHandler'
import BreadcrumbDispatch from '../../_partials/breadcrumbDispatch';

const useStyles = makeStyles(() => ({
  detailsPaper: {
    marginBottom: '40px',
    backgroundColor: '#F6F6F6',
    padding: '30px 0px 30px 15px',
    width: '100%',
  },
  Button: {
    width: '120px',
    marginRight: '20px',
    '&:hover': {
      background: '#52A1C2',
    },
  },
  helpIcon: {
    marginBottom: '10px',
    marginLeft: '0.5px',
    width: '20px',
  },
  HelpBlockImg: {
    display: 'block',
    margin: 'auto',
    width: '100%',
    marginTop: '100px',
  },
  containerPaper: {
    height: '100%',
    padding: '30px',
    opacity: '1',
  },
  searchField: {
    marginTop: '-0.75em',
    marginRight: '20px',
  },
  findingFieldSelect: {
    width: '120px',
    height: '50px',
  },
  outlinedInput: {
    padding: '0px',
  },
}))

export default function SelectScope() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [openCreateDialog, setOpenCreateDialog] = useState(false)
  const [scopeDataString, setscopeDataString] = useState('')
  const queryValues = queryString.parse(history.location.search)
  const {machine_type, hmi_type} = queryValues
  const findingRuleId = queryValues.findingRuleId
  const [createScopedFindingSuccess, setCreateScopedFindingSuccess] =
    useState(false)
  const [createScopedFindingFailure, setCreateScopedFindingFailure] =
    useState(false)
  const [chosenFindingRule, setChosenFindingRule] = useState('')
  const [findingField, setFindingField] = useState('')
  const [findingFieldAdded, setFindingFieldAdded] = useState('')

  const selectFindingRuleResponse = useSelector(
    (state) => state.selectFindingRule
  )

  const scopedFindingRuleResponse = useSelector(
    (state) => state.scopedFindingRule
  )

  useEffect(() => {
    if(!history.location.search)
    {
      history.push('/rules');
      return;
    }
    dispatch(fetchSelectFindingRule(findingRuleId, machine_type, hmi_type))
    dispatch(fetchFindingField(machine_type,hmi_type))
  }, [])

  useEffect(() => {
    if (selectFindingRuleResponse) {
      setFindingField(selectFindingRuleResponse.selectFindingField)
    }
  }, [selectFindingRuleResponse.selectFindingField])

  useEffect(() => {
    selectFindingRuleResponse.selectFindingRule &&
    selectFindingRuleResponse.selectFindingRule
        .filter((ids) => ids.id === findingRuleId)
        .map((finding) => {
          setChosenFindingRule(finding)
          if (finding.findingField) {
            setFindingFieldAdded(finding.findingField.name)
          } else {
            setFindingFieldAdded('none')
          }
        })
  }, [selectFindingRuleResponse.selectFindingRule])

  const getScopeData = (scopeData) => {
    var filterScopeDataValue = scopeData.split(/[:]/)
    dispatch(persistFilterData(filterScopeDataValue))
    setscopeDataString(scopeData)
  }

  const handleClose = () => {
    setOpenCreateDialog(false)
  }

  const handleFindingFieldChange = (event, chosenFindingRule) => {
    let changedFindingField
    setFindingFieldAdded(event.target.value)
    changedFindingField = findingField.filter(
      (item) => item.name === event.target.value
    )
    if (event.target.value !== 'none') {
      const body = {
        id: chosenFindingRule.id,
        name: chosenFindingRule.name,
        description: chosenFindingRule.description,
        finding_field_id: changedFindingField[0].id,
      }
      dispatch(editFindingRule(chosenFindingRule.id, body,machine_type,hmi_type))
    } else {
      const body = {
        id: chosenFindingRule.id,
        name: chosenFindingRule.name,
        description: chosenFindingRule.description,
        finding_field_id: event.target.value,
      }
      dispatch(editFindingRule(chosenFindingRule.id, body,machine_type,hmi_type))
    }
  }

  return (
    <Grid container direction='row' spacing={4}>
      <BreadcrumbDispatch />
      <Grid item md={9}>
        <Paper className={classes.containerPaper}>
          <Grid
            container
            direction='row'
            style={{ marginBottom: '1em' }}
            justifyContent='space-between'
            alignItems='center'
          >
            <Grid item style={{ marginBottom: '30px' }}>
              <Grid container>
                <Grid item>
                  <Typography
                    className='text-secondary'
                    variant='h5'
                    style={{ color: '#52A1C2', fontSize: '1.5rem' }}
                  >
                    Select Scoped Finding Rule
                  </Typography>
                </Grid>
                <Grid item>
                  <Tooltip title='question'>
                    <HelpOutlineIcon className={classes.helpIcon} />
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
            <Grid item style={{ marginBottom: '30px' }}>
              <Grid container>
                <Grid item>
                  <Button
                    variant='outlined'
                    onClick={() => setOpenCreateDialog(true)}
                  >
                    {' '}
                    + CREATE NEW
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item >
            <Paper className={classes.detailsPaper} elevation={0}>
              <Grid container direction='column' spacing={2}>
                {chosenFindingRule
                  && findingField &&
                      <>
                        <Grid item container direction='row'>
                          <Grid item md={5}>
                            <Typography variant='subtitle2'>
                              Finding Rule Name
                            </Typography>
                          </Grid>
                          <Grid item md={1}>
                            -
                          </Grid>
                          <Grid item md={6}>
                            <Typography className='black-text'>
                              {chosenFindingRule.name}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                        item
                          container
                          direction='row'
                        >
                          <Grid item md={5}>
                            <Typography variant='subtitle2'>
                              Finding Field
                            </Typography>
                          </Grid>
                          <Grid item md={1}>
                            -
                          </Grid>
                          <Grid item md={1}>
                            <Select
                              className={classes.findingFieldSelect}
                              id='finding_field_select'
                              variant='outlined'
                              displayEmpty
                              value={findingFieldAdded}
                              onChange={(event) =>
                                handleFindingFieldChange(event,chosenFindingRule)
                              }
                              MenuProps={{
                                anchorOrigin: {
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                },
                                getContentAnchorEl: null,
                              }}
                            >
                              {findingField &&
                                findingField.map((item) => (
                                  <MenuItem
                                    key={`${item.name}${item.id}`}
                                    id={item.id}
                                    value={item.name}
                                  >
                                    {item.name}
                                  </MenuItem>
                                ))}
                            </Select>
                          </Grid>
                        </Grid>
                      </>
                    }
              </Grid>
            </Paper>
          </Grid>
          <Grid item style={{ marginBottom: '30px' }}>
            <p>
              Select machine type,customer, factory or serial number to filter
              the table below. Pick an existing scoped finding rule from the
              table or create a new one.
            </p>
          </Grid>
          <Grid container direction='row' spacing={3}>
            <Grid item container>
              <SelectScopeMenu getScopeData={getScopeData} />
            </Grid>
            <Grid item xs={12}>
              <ScopeList scopeDataString={scopeDataString} />
            </Grid>
          </Grid>
        </Paper>
        {/* Create new scope */}
        {openCreateDialog && (
          <CreateScope
            open={openCreateDialog}
            onClose={(e) => handleClose()}
            setCreateScopedFindingSuccess={setCreateScopedFindingSuccess}
            setCreateScopedFindingFailure={setCreateScopedFindingFailure}
          />
        )}
      </Grid>
      <Grid item md={3} className='helpBlock'>
        <Paper className={classes.containerPaper}>
          <Box component='div' className='helpBlockTitle'>
            Help
          </Box>
          <br />
          <p className='helpTest'>
            The scope defines which machines are affected by your configuration
            of the scoped finding rule.
          </p>
          <br />
          <p className='helpTest'>
            You can consecutively define a machine type,a customer,a factory,and
            even a single machine.
          </p>
          <br />
          <hr style={{ color: '#E5E5E5' }} />
          <b className='helpQuestion'>Level of Scope:</b>
          <br />
          <br />
          <p className='helpTest'>
            Select a machine type,customer,factory or serial number to filter
            the table below.
          </p>
          <br />
          <p className='helpTest'>
            Pick an existing scoped finding rule from the table or create a new
            one.
          </p>
          <br />
          <Box component='div'>
            <img
              src={HelpBlockImg}
              alt='HelpBlockImg'
              className={`img-fluid ${classes.HelpBlockImg}`}
            />
          </Box>
        </Paper>
      </Grid>

      {createScopedFindingSuccess && (
        <CreateScopeSuccess
          open={createScopedFindingSuccess ? true : false}
          setCreateScopedFindingSuccess={setCreateScopedFindingSuccess}
          value={createScopedFindingSuccess}
        />
      )}

      {/* Error when create scope fails */}
      {createScopedFindingFailure && (
        <ErrorHandler message={scopedFindingRuleResponse.error} />
      )}
    </Grid>
  )
}
